
import React,{forwardRef,useEffect,useState, useRef, Fragment, useMemo} from 'react';
import {getContentPath} from 'system/AssetManager.js';
import Globals from 'system/Globals.js';
import gsap,{Power2} from 'gsap';
import SVG from 'react-inlinesvg';
import classNames from 'classnames';
import { addDays, differenceInCalendarDays, format, parseISO, getMonth, getDate, getYear, formatISO } from 'date-fns';
import nStyles from '../../narrative.module.scss'
import {ReactComponent as ZoomOut} from 'assets/icons/minus.svg'
import {ReactComponent as ZoomIn} from 'assets/icons/plus.svg'
import mstyles from '../modules.module.css';
import styles from './timeline.module.css';
import LoaderWheel from 'system/components/LoaderWheel.js';
import ScrollBar from '../scrollbar';
import ToolsMenu from 'system/components/ToolsMenu.js'
import EventIcon from './eventIcon';

// import {ReactComponent as CloseButton} from 'assets/icons/close.svg'
import {ReactComponent as Calendar} from 'assets/icons/calendar.svg'
import {ReactComponent as Arrow} from 'assets/icons/timeline-arrow.svg'
import {ReactComponent as Burger} from 'assets/icons/burger.svg';
import {ReactComponent as FilterIcon} from 'assets/icons/timeline_filter.svg';
import {ReactComponent as CaretRight} from 'assets/icons/caret_right.svg'
import {ReactComponent as CaretLeft} from 'assets/icons/caret_left.svg'
import {ReactComponent as CaretDown} from 'assets/icons/caret_down.svg'
import {ReactComponent as CaretUp} from 'assets/icons/caret_up.svg'
// import {ReactComponent as Return} from 'assets/icons/return.svg'
import {ReactComponent as Home} from 'assets/icons/expo-home-icon.svg'
import {ReactComponent as Apps} from 'assets/icons/apps.svg'
import {ReactComponent as Predict} from 'assets/icons/predict.svg'

const Timeline = forwardRef((props, ref)=>{

    // const zoom = useMemo(() => [
    //   { level: 'year', heading: 'Yearly', number: 1.1, width: 394},
    //   { level: 'month', heading: 'Monthly', number: 9.87, width: 294},
    //   { level: 'week', heading: 'Weekly', number: 43.4, width: 294},
    //   { level: 'day', heading: 'Daily', number: 200, width: 194 }
    // ], []);

    const scrollingContainerRef = useRef();
    const refServerAppListener = useRef();
    const [unitCount, setUnitCount] = useState(0);
    const [zoomIndex, setZoomIndex] = useState(0);
    const [totalDays, setTotalDays] = useState(0);
    const [loaded,setLoaded] = useState(false);
    const [status,setStatus] = useState('initializing');
    const [events, setEvents] = useState(null);
    const [timeline, setTimeline] = useState(null);
    const [navOpen, setNavOpen] = useState(false);
    const [backgroundColor, setBackgroundColor] = useState('black');
    const [showModules, setShowModules] = useState(false);
    const [lines, setLines] = useState(null);
    const [primaryLines, setPrimaryLines] = useState(null);
    const [filters, setFilters] = useState(null);
    const [filtersOn, setFiltersOn] = useState([]);
    const [showActualPredicted, setShowActualPredicted] = useState(false);
    const [eventBlocksHeight, setEventBlocksHeight] = useState(false);
    const [scrollX, setScrollX] = useState(null);
    const [centerDay, setCenterDay] = useState(null);
    const [centerEvent, setCenterEvent] = useState(null);
    const [scrollBarPos, setScrollBarPos] = useState([0, 0]);
    const [predictedOn, setPredictedOn] = useState(false);
    const [zoom, setZoom] = useState([
      { level: 'year', heading: 'Yearly', number: 1.1, width: 394},
      { level: 'month', heading: 'Monthly', number: 9.87, width: 294},
      { level: 'week', heading: 'Weekly', number: 43.4, width: 294},
      { level: 'day', heading: 'Daily', number: 200, width: 194 }
    ]);

    const MIN_DAY_LINE_ZOOM = 28;
    const showDayLines = zoom >= MIN_DAY_LINE_ZOOM;

    function isCrossYearEvent(start_date, end_date) {
      if (!start_date || !end_date) return false;
      const startYear = getYear(parseISO(start_date));
      const endYear = getYear(parseISO(end_date));
      let years = parseInt(endYear) - parseInt(startYear);
      // console.log('startYear', startYear, 'endYear', endYear, 'years', years)
      return years;
    }

    function getClosestDatelineToCenter() {
      const centerX = window.innerWidth / 2;
      const datelines = document.querySelectorAll('.dateLine');
    
      let closestElement = null;
      let closestDistance = Infinity;
      datelines.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const elCenterX = rect.left + rect.width / 2;
        const distance = Math.abs(elCenterX - centerX);
    
        if (distance < closestDistance) {
          closestDistance = distance;
          closestElement = el;
        }
      });
      // console.log('getClosestDatelineToCenter', closestElement?.dataset.day)
      return closestElement;
    }

    function moveBlock(id, i, isUp) {
    
        const el = document.getElementById(id)
        const currentTop = parseInt(el.dataset.top);
        const count = parseInt(el.dataset.events);
        let offset;  
        if (showActualPredicted) {
            if (isUp) {
            offset = (currentTop - (30 * count) - 30);
            } else {
            offset = currentTop + (30 * count) + 30;
            }
        } else {
            offset = currentTop;
            removeParamUrl('predicted');
        }
        // console.log('moveBlock Offset', offset, id, count, isUp, showActualPredicted)
        el.style.top = offset + 'px';
    }

    function moveBlockCrossYear(id, parentId) {
    
        const el = document.getElementById(id)
        const parent = document.getElementById(parentId);
        let parentYPos = parent?.style.top ?? 0;
        console.log('moveBlockCrossYear', parentYPos)
        // const currentTop = parseInt(parent.dataset.top);
        // const count = parseInt(el.dataset.events);
        let offset;  
        if (showActualPredicted) {
            offset = parentYPos;
        } else {
            offset = parentYPos;
            removeParamUrl('predicted');
        }
        // console.log('moveBlock Offset', offset, id, count, isUp, showActualPredicted)
        el.style.top = offset;
    }

    function removeParamUrl(name){
        let params = new URLSearchParams(props.history.location.search);
        params.delete(name)
        props.history.replace({ pathname:props.history.location.pathname, search:decodeURIComponent(params.toString())})
    }

    function onClickClose(evt){
        props.closeModule()
        removeParamUrl('context');

    }  


    function getEventBlockExtentsRelative() {
        const container = document.querySelector('#scrollContainerV');
        if (!container) return null;
        const containerRect = container.getBoundingClientRect();

        const blocks = document.querySelectorAll('.eventBlock');
        if (!blocks.length) return null;

        let minY = Infinity;
        let maxY = -Infinity;

        blocks.forEach(el => {
          const rect = el.getBoundingClientRect();
          const top = rect.top - containerRect.top;
          const bottom = rect.bottom - containerRect.top;
          if (top < minY) minY = top;
          if (bottom > maxY) maxY = bottom;
        });

        return { top: minY, bottom: maxY };
      }
    
    
    function processParams(){
      // console.log('processParams')
      // removeParamUrl('slide');
      let params = new URLSearchParams(props.history.location.search);
      let eventParam = params.get('timeline');
      let showPredicted = params.get('predicted');
      let eventParamAlt = params.get('timeline-event');
      
      let hasParams = false
      if (eventParam) {
        let eventArray = eventParam.split('-');
        
        if (eventArray.length > 1) {
          let eventBlock = eventArray[0];
          let zoomLevel = eventArray[1];
          if (eventBlock && zoomLevel) {
            function callBack(){
              scrollToEvent(eventBlock, false, true);
              showPredicted === 'true' && setShowActualPredicted(true)
            }
             onZoom(zoomLevel, callBack);
          }
          hasParams = true
        }
      }
      if (eventParamAlt) {
        scrollToEvent(eventParamAlt, false, true);
        showPredicted === 'true' && setShowActualPredicted(true)
        hasParams = true
      }

      return hasParams;
    }

    useEffect(()=>{ 
    
        ref.current.style.display='block';
        gsap.from(ref.current,{duration:0.5,opacity:0,top:'80%', ease:Power2.easeInOut,onComplete:()=>{
        }});

        (async ()=>{
            try { 
               
                setStatus('Loading JSON')
                if (props.model) {
                    setTimeline(props.model)
                }

                if (props.model.events) {
                    console.log('Timeline JSON', props.model)
                    // props.preAnimateWindowIn()
                    setEvents(props.model.events);
                    if (props.model.backgroundColor) {
                        setBackgroundColor(props.model.backgroundColor);
                    }
                   
                }
                setStatus('Setting Timeline')
           
            }catch(err){
          
            }
        })();  


     
        return () => {

        }

    },[]);

    useEffect(()=>{
      if (!showActualPredicted) {
        setPredictedOn(false)
      }
    }, [showActualPredicted]);  

    // Wait until events is a non-empty array, then run cb
function waitForEventsThen(cb, intervalMs = 50, maxWaitMs = 5000) {
  if (Array.isArray(events) && events.length > 0) {
    cb();
    return;
  }
  const start = Date.now();
  const t = setInterval(() => {
    if (Array.isArray(events) && events.length > 0) {
      clearInterval(t);
      cb();
    } else if (Date.now() - start >= maxWaitMs) {
      clearInterval(t);
      // Last-resort attempt so we do not drop the command
      cb();
    }
  }, intervalMs);
}

    useEffect(()=>{ 
        if (loaded) {
           
            if (Globals.instance().serverApp || props.socketPrefs.mode === "isReceive") {
              
                window.removeEventListener('server-event', refServerAppListener.current)
                const serverAppListener = (evt)=>{
                    let detail = evt.detail
                    if(!detail)return
                    if(detail.event==='module-timeline-select-event'){ 

                      if (predictedOn) {
                        onSelectEvent('event_p_' + parseInt(detail.command));
                        scrollToEvent('event_p_' + parseInt(detail.command), false, true);
                      } else {
                        onSelectEvent('event_' + parseInt(detail.command));
                        scrollToEvent('event_' + parseInt(detail.command), false, true);
                      }
                      
                      
                      
                      if (props.socket) {
                          props.socket.emit('handshake', [props.socketPrefs.room, props.socket.id, 'module-gallery-select-file?command=' + detail.command]);
                          console.log('page handsake sent', 'module-gallery-select-file?command=' + detail.command);
                      }
                        
                    }
                    if (detail.event==='module-timeline-select-filter'){
                        let id = parseInt(detail.command);
                        let copy = [...filtersOn];
                        let index = copy.indexOf(id);
                         console.log('module-timeline-select-filter recd', id, copy, filtersOn, index)
                        if (index > -1) {
                           copy.splice(index, 1)
                        } else {
                           copy.push(id)
                        }
                        setFiltersOn(copy);
                    }
                    if (detail.event === "module-timeline-select-filters") {
                        // waitForEventsThen(() => {
                        //   setFiltersOn(JSON.parse(detail.command));
                        //   console.log('module-timeline-select-filters applied', detail.command);
                        // });
                        setFiltersOn(JSON.parse(detail.command));
                        // setFiltersOn(JSON.parse(detail.command));
                        console.log('module-timeline-select-filters recd', detail.command)
                    }
                    if (detail.event === "module-timeline-clear-filters") {
                        setFiltersOn([]);
                    }
                     if (detail.event === "module-timeline-show-actualpredicted") {
                       setShowActualPredicted(prev => !prev);  

                    }
                    if (detail.event === "module-timeline-show-actual") {
                       let id = parseInt(detail.command);
                       goToEvent("event_p_" + id, "event_" + id)
                       setPredictedOn(false)

                    }
                    if (detail.event === "module-timeline-show-predicted") {
                       let id = parseInt(detail.command);
                       goToEvent("event_" + id, "event_p_" + id)
                       setPredictedOn(true)
                    }
                    if(detail.event==='module-timeline-command'){ 
                        
                       switch(detail.command) {
                            case 'zoom-in':
                              onZoomIn();
                              break;
                            case 'zoom-out':
                              onZoomOut();
                              break;  
                            case 'up':
                              console.log('up');

                              gsap.to('#scrollContainerV', {y: '-=100', duration: 0.2})
                              break;
                            case 'down':
                              console.log('down');
                              gsap.to('#scrollContainerV', {y: '+=100', duration: 0.2})
                              break;  
                            default:
                                {}
                       }
                    }
                }
               
                refServerAppListener.current = serverAppListener
                window.addEventListener('server-event', refServerAppListener.current)
                
            }
        } 
        
    },[loaded, filtersOn, onZoomOut, onZoomIn, events, timeline]);


    useEffect(() => {
        if (timeline && events && props) {
            // console.log('timeline, events', timeline, events);

            (loaded === false) && props.animateWindowIn()
            setLoaded(true)

            // const totalDays = differenceInCalendarDays(timeline.end_date, timeline.start_date);
            setTotalDays(timeline.lines.total_days);

            setLines(timeline.lines.days)

            if (timeline.lines.years && timeline.lines.years.length > 9 ) {
              setZoom([{ level: 'year', heading: 'Yearly', number: 0.55, width: 197}, { level: 'year', heading: 'Yearly', number: 1.1, width: 394},
      { level: 'month', heading: 'Monthly', number: 9.87, width: 294},
      { level: 'week', heading: 'Weekly', number: 43.4, width: 294},
      { level: 'day', heading: 'Daily', number: 200, width: 194 }]);
            }

            if (!filters) {
              let newList = [];

              timeline.tags.forEach((obj, i) => {
              let exists = newList.findIndex(a => a.id === parseInt(obj.id))
    
                if (!obj.parent && exists < 0) {
                  
                    let listObj = {
                        id: parseInt(obj.id),
                        text: obj.text,
                        children: []
                    }
                    newList.push(listObj);
    
                } else {
                  
                  let parentIndex = newList.findIndex(a => a.id === parseInt(obj.parent))
                  console.log('parentIndex', parentIndex, obj.parent, newList)
    
                  if (parentIndex > -1) {
                    newList[parentIndex] && newList[parentIndex]['children'].push({
                      id: parseInt(obj.id),
                      text: obj.text,
                      children: []
                    });
               
                  } 
                  else {
                    let parentObj = timeline.tags.find(a => a.id === obj.parent);
                      if (parentObj){
                        let listObj = {
                          id: parentObj.id,
                          text: parentObj.text,
                          visible: null,
                          locked: null,
                          children: [{
                            id: obj.id,
                            text: obj.text,
                            children: []
                          }]
                        }
                        console.log('listObj', listObj)
                        newList.push(listObj);
                      }
                    
                      
                  }
                 
                }
    
            });
            console.log("newList", newList)
            setFilters(newList);
    

            }

           
            
        }
    }, [timeline, events, props])


    useEffect(() => {
      if (timeline && zoom && zoomIndex !== undefined){
        
        switch (zoom[zoomIndex].level) {
          case '5-year':
            console.log('5-year')
            
            setPrimaryLines(timeline.lines.years?.map(d => ({ ...d })) ?? []);
            break;
          case 'year':
            console.log('year')
            setPrimaryLines(timeline.lines.years?.map(d => ({ ...d })) ?? []);
            break;
          case 'month':
            console.log('month')
            setPrimaryLines(timeline.lines && timeline.lines.months)
            break;

          case 'week':
            console.log('week')
            setPrimaryLines(timeline.lines && timeline.lines.weeks)
            break

          case 'day':
            setPrimaryLines(timeline.lines && timeline.lines.days)
            break
        
          default:
            break;
        }

        saveCenterLine();
        
      
      }
    }, [zoomIndex, zoom, timeline])

    useEffect(() => { 
      // console.log('zoom', zoom)
      if (centerEvent) {
        // getScrollX() 
      }
    }, [centerEvent])


    function getDaysInMonth(dateInput) {
      const date = (dateInput instanceof Date) ? dateInput : parseISO(dateInput);
      const year = date.getFullYear();
      const month = date.getMonth(); // 0-indexed
      return new Date(year, month + 1, 0).getDate();
    }

    function placeEvents(){
      console.log('placeEvents started', primaryLines.length)
      
      // gsap.to('.eventBlock', {opacity: 0, duration: 0.3});
      let days = 0;
      let blockWidth = zoom[zoomIndex].width;
      let yearEventsTotal = 0;
      let monthEventsTotal = 0;
      let weekEventsTotal = 0;
      let dayEventsTotal = 0;
      
      let yearEvents = [];
      let monthEvents = [];
      let weekEvents = [];
      let dayEvents = [];
      let allEventCount = 0;

      let opacity = 1;

      if (filtersOn && filtersOn.length > 0) {
        opacity = 0;
      }

      let yPosArray = [];

      function processDate(obj, isMultiDay) {
        let dateParts = obj.start_date_parts;
        let datePartsP = obj.start_date_predicted_parts;
        let date;
        let dateP;
        let eventCount = 0;
        let line;
        let lineP;
        let topOffset = 0;
        if (showActualPredicted) {
          topOffset = 30; 
        }
        switch (zoom[zoomIndex].level) {
          case "year":
            date = dateParts['year']
            line = document.querySelector('[data-year="' + date + '"]');
            dateP = datePartsP['year']
            lineP = document.querySelector('[data-year="' + dateP + '"]');
            let yearIndex = yearEvents.findIndex(a => a.value === date)
            if (yearIndex > -1) {
              eventCount = yearEvents[yearIndex]['count']+=1;
              yearEvents[yearIndex]['count'] = eventCount;
            } else {
              yearEvents.push({value: date, count: 0})
            }
            break;
          case "month":
            days = getDaysInMonth(obj.start_date)
            blockWidth = (scrollingContainerRef.current.offsetWidth/totalDays * days);
            date = dateParts['year'] + '-' + dateParts['month']
            line = document.querySelector('[data-month="' + date + '"]');
            dateP = datePartsP['year'] + '-' + datePartsP['month']
            lineP = document.querySelector('[data-month="' + dateP + '"]');
            let monthIndex = monthEvents.findIndex(a => a.value === date)
            if (monthIndex > -1) {
              eventCount = monthEvents[monthIndex]['count']+=1
              monthEvents[monthIndex]['count'] = eventCount
            } else {
              monthEvents.push({value: date, count: 0})
            }
            break;
          case "week":
            days = 7
            blockWidth = (scrollingContainerRef.current.offsetWidth/totalDays * days);
            date = dateParts['year'] + '-' + dateParts['week'] 
            line = document.querySelector('[data-week="' + date + '"]');
            dateP = datePartsP['year'] + '-' + datePartsP['week'] 
            lineP = document.querySelector('[data-week="' + dateP + '"]');
            let weekIndex = weekEvents.findIndex(a => a.value === date)
            if (weekIndex > -1) {
              eventCount = weekEvents[weekIndex]['count']+=1
              weekEvents[weekIndex]['count'] = eventCount
            } else {
              weekEvents.push({value: date, count: 0})
            }
            break;
          case "day":
            days = 1
            blockWidth = (scrollingContainerRef.current.offsetWidth/totalDays * days);
            date =  obj.start_date
            line = document.querySelector('[data-day="' + date + '"]');
            dateP =  obj.start_date_predicted
            lineP = document.querySelector('[data-day="' + dateP + '"]');
            // console.log('date check', date)
            let dateIndex = dayEvents.findIndex(a => a.value === date)
            if (dateIndex > -1) {
              eventCount = dayEvents[dateIndex]['count']+=1
              dayEvents[dateIndex]['count'] = eventCount
            } else {
              dayEvents.push({value: date, count: 0})
            }
            break;
          default:
            break;
        }

        let dayLine = document.querySelector('[data-day="' + obj.start_date + '"]');
        let lineX;
        let lineXDay;
        let topPos;
        if (line) {
          lineX = line.offsetLeft;
        }
        if (dayLine) {
          lineXDay = dayLine.offsetLeft;
        }
        let centerV = window.innerHeight*0.5-200;

        if (isMultiDay) {
          let offset = 0;
          if (zoom[zoomIndex].level === "month") {
            offset = 8
          }
          topPos = centerV + 130 + (allEventCount * 84);
          yPosArray.push(topPos);
          function fadeIn() {
            // gsap.to('#event_' + obj.id, {opacity: 1, duration: 0.1})
          }
          gsap.to('#event_' + obj.id, {left: zoom[zoomIndex].level === "year" ? lineX : lineXDay + offset, opacity: opacity, width: zoom[zoomIndex].level !== "year" ? (zoom[zoomIndex].number * (obj.days + 1)) - 12 : zoom[zoomIndex].width - 12, top: (topPos + (topOffset * allEventCount) + topOffset), duration: 0, onComplete: fadeIn()});

          document.getElementById('event_' + obj.id).dataset.top = topPos;
          document.getElementById('event_' + obj.id).dataset.events = allEventCount;
         
          let dayLineP= document.querySelector('[data-day="' + obj.start_date_predicted + '"]');
          let lineXDayP;
          if (dayLineP) {
            lineXDayP = dayLineP.offsetLeft;
            topPos = centerV + 107 + (allEventCount * 100);
            yPosArray.push(topPos);
            gsap.to('#event_p_' + obj.id, {opacity: opacity, left: zoom[zoomIndex].level === "year" ? lineX : lineXDayP + offset, width: zoom[zoomIndex].level !== "year" ? (zoom[zoomIndex].number * (obj.days_predicted + 1)) - 12 : zoom[zoomIndex].width - 12, top: (topPos + (topOffset * allEventCount) + topOffset), duration: 0});

            document.getElementById('event_p_' + obj.id).dataset.top = topPos;
            document.getElementById('event_p_' + obj.id).dataset.events = allEventCount;
          }
          getScrollX();
          // console.log(obj.id, zoomIndex, isCrossYearEvent(obj.start_date, obj.end_date))

          if (zoom[zoomIndex].level === "year" && isCrossYearEvent(obj.start_date, obj.end_date) > 0) {

              let endDate = parseInt((parseISO(obj.end_date).getFullYear()));
              let years = endDate - parseInt(date);
              console.log('parseInt(date)', parseInt(date), 'endDate', endDate, 'years', years)

              function placeMultiYearEndBlock(obj, date, yearInt, baseId) {
                let elId = baseId;
                const el = document.getElementById(elId);
                line = document.querySelector('[data-year="' + (parseInt(date) + yearInt) + '"]');
                // console.log('placeMultiYearEndBlock', obj.id, parseInt(date) + yearInt)
                if (line) {
                  lineX = line.offsetLeft;
                  topPos = centerV + 130 + (allEventCount * 84);
                  yPosArray.push(topPos);
                  gsap.to('#' + elId, {opacity: opacity, left: lineX, width: zoom[zoomIndex].level !== "year" ? (zoom[zoomIndex].number * (obj.days + 1)) - 12 : zoom[zoomIndex].width - 12, top: (topPos + (topOffset * allEventCount) + topOffset), duration: 0});
                  el.dataset.top = topPos;
                  el.dataset.events = eventCount;
                }
              }

              for (let index = 0; index < years; index++) {
                 const baseId = 'event_y_' + obj.id + '_' + (index);
                  placeMultiYearEndBlock(obj, date, index + 1, baseId);

                  if (obj.start_date_predicted) {
                    const baseIdP = 'event_p_y_' + obj.id + '_' + (index);
                    placeMultiYearEndBlock(obj, date, index + 1, baseIdP);
                  }

              }
          
          }


        } else {
          topPos = centerV - (eventCount * 80);
          yPosArray.push(topPos);

          function fadeIn() {
            // gsap.to('#event_' + obj.id, {opacity: 1, duration: 0.1})
          }
          gsap.to('#event_' + obj.id, {opacity: opacity, left: lineX, top: (topPos - (topOffset * eventCount) - topOffset), width: blockWidth-12, duration: 0, onComplete: fadeIn()});

          document.getElementById('event_' + obj.id).dataset.top = topPos;
          document.getElementById('event_' + obj.id).dataset.events = eventCount;

           if (obj.start_date_predicted) {
             if (lineP) {
                let linePx = lineP.offsetLeft;
                topPos = topPos + 6;
                gsap.to('#event_p_' + obj.id, {opacity: opacity, left: linePx, top: topPos - (topOffset * eventCount) - topOffset, width: blockWidth-12, duration: 0});
              
                document.getElementById('event_p_' + obj.id).dataset.top = topPos;
                document.getElementById('event_p_' + obj.id).dataset.events = eventCount;
              }
           
             
          }
        }
        
       
        
      }

      events.filter(a => a.multi_day === true).forEach((obj, i) => {
        
        processDate(obj, true)
        allEventCount+=1;
      });

      yearEvents = [];
      monthEvents = [];
      weekEvents = [];
      dayEvents = [];

      events.filter(a => a.multi_day === false).reverse().forEach((obj, i) => {
      
        processDate(obj, false)
          allEventCount+=1;
        if (obj.icon) {
          onSvgLoad("svg_" + obj.id, obj.start_date)
        }
        if (obj.icon && obj.start_date_predicted) {
          onSvgLoad("svg_p_" + obj.id, obj.start_date_predicted)
        }
      });

      let dateLine = document.querySelector('[data-day="' + format(Date.now(), 'yyyy-MM-dd') + '"]');
      let dateLineX;
      if (dateLine) {
        dateLineX = dateLine.offsetLeft;
      }
      if (dateLine) {
        gsap.set('#nowLine', {left: dateLineX - 4});
      } else {
        gsap.set('#nowLine', {opacity: 0});
      }
      // console.log('lastYPos')
      const lowest = Math.min(...yPosArray);
      const highest = Math.max(...yPosArray) + 120;
      console.log('lowest', highest, lowest)
      // setEventBlocksHeight(highest-lowest);
      setEventBlocksHeight(getEventBlockExtentsRelative().top-getEventBlockExtentsRelative().bottom);
      

      if (events[0] && lines[0]) {
        let hasParams = processParams();
       
        if (!hasParams) {
          console.log('processParams', hasParams, scrollX)
          if (centerEvent) {
            let scrollCenter = centerEvent[0];
            if (centerEvent.length > 1) {
              scrollCenter = centerEvent[1];
            }
            console.log('scrollCenter', scrollCenter, centerEvent);
            setTimeout(() => {
              scrollToEvent(scrollCenter, false, true)
            }, 300);
          }
        }

        if (scrollX > 0) {
          
        } else {
          if (hasParams === false) {
            // if (start_date > timeline_start_date) {
            //   setTimeout(() => {
            //     scrollToEvent('event_' + events[0].id)
            //   }, 300);
            // }
            
          }
        }

 
      
      }

      switch (zoom[zoomIndex].level) {
        case "year":
          setUnitCount(yearEventsTotal)
          break;
        case "month":
          setUnitCount(monthEventsTotal)
          break;
        case "week":
          setUnitCount(weekEventsTotal)
          break;
        case "day":
          setUnitCount(dayEventsTotal)
          break;
        default:
          break;
      }
      setTimeout(() => {


        if (filtersOn && filtersOn.length > 0) {
           filtersOn.forEach(obj => {
            gsap.to('.eventBlock.tag' + obj, {opacity: 1})
            gsap.to('.eventIcon.tag' + obj, {opacity: 1})
            if (showActualPredicted) {
              gsap.to('.eventIconP.tag' + obj, {opacity: 0.7})
            }
         })
        }
       
       


      }, 100);
      


      
    }


    useEffect(()=>{ 
      let observer;

        if (events && lines && scrollingContainerRef.current && primaryLines && zoom) {
          setLoaded(true)
          ref.current.classList.remove(styles.zooming);
          // gsap.to(styles.eventBlock, {opacity: 0, duration: 0.2})
          let firstLine = document.querySelector('[data-day="' + lines[0].date + '"]');
          // console.log('firstLine', lines[0].date , firstLine)
          if (firstLine) {
            let lineX = firstLine.offsetLeft;
            let width = document.getElementById('scrollingContainer').offsetWidth + 300;
            // console.log("width", width)
            gsap.set('#centerLine', {left: lineX, 'width': width});
            console.log('lineX', lines[0].date , firstLine, lineX)
          }
          

          window.addEventListener("resize", (event) => {
            placeEvents();
          });
          
          setTimeout(() => {
            placeEvents();
          }, 200); 
       

        }   

        return () => {
          window.removeEventListener('resize', placeEvents);
          observer && observer.disconnect();
        }
        
    },[primaryLines, events, lines, scrollingContainerRef.current]);

   

    useEffect(() => {
     
         events && events.filter(a => !a.multi_day).forEach((obj, i) => {
          moveBlock('event_' + obj.id, i, true)
          if (obj.start_date_predicted) {
            moveBlock('event_p_' + obj.id, i, true)
          }
        });

        events && events.filter(a => a.multi_day).forEach((obj, i) => {
          moveBlock('event_' + obj.id, i, false)
          if (obj.start_date_predicted) {
            moveBlock('event_p_' + obj.id, i, false);
           
          }
      
           if (i === events.filter(a => a.multi_day).length - 1) {
     
                setTimeout(() => {
                    adjustCrossYearBlocks();
                }, 0);
            }
        });


         function adjustCrossYearBlocks(){
          events && events.filter(a => a.multi_day).forEach((obj, i) => {
            (isCrossYearEvent(obj.start_date, obj.end_date) > 0) && zoom[zoomIndex].level === "year" && Array.from({ length: isCrossYearEvent(obj.start_date, obj.end_date)}).forEach((_, j) => {
                let parent = `event_${obj.id}`;
                moveBlockCrossYear(`event_y_${obj.id}_${j}`, parent);
                if (obj.start_date_predicted) {
                   let parentP = `event_p_${obj.id}`;
                  moveBlockCrossYear(`event_p_y_${obj.id}_${j}`, parentP);
                }
               
              });
          });
        }
     
  
    


        setTimeout(() => {
          filtersOn.length > 0 ? filtersOn.forEach(obj => {
              gsap.to('.eventBlock.tag' + obj, {opacity: 1})
              gsap.to('.eventIcon.tag' + obj, {opacity: 1})
              if (showActualPredicted) {
                gsap.to('.eventIconP.tag' + obj, {opacity: 0.7})
              } else {
                gsap.to('.eventIconP.tag' + obj, {opacity: 0})
              }
            }) :  (showActualPredicted) ? gsap.to('.eventIconP', {opacity: 0.7}) : gsap.to('.eventIconP', {opacity: 0})
        }, 50);

        if (!showActualPredicted) {
          let els = document.querySelectorAll('.eventBlock');
         els.forEach(el => {
            el.classList.add(styles.eventOn);
          });




        } else {

                      
          // const lowest = Math.min(...yPosArray);
          // const highest = Math.max(...yPosArray) + 120;
          // console.log('lowest', getEventBlockExtentsRelative().top, getEventBlockExtentsRelative().bottom)

        setEventBlocksHeight(getEventBlockExtentsRelative().top-getEventBlockExtentsRelative().bottom);
         
        }

    
        return () => {    

        }
     
    }, [showActualPredicted])


      


    useEffect(() => {
      if (filtersOn && filtersOn.length > 0 && events && events.length > 0) {

        console.log('filtersOn', filtersOn, events)
        setCenterEvent(null);
        
        setTimeout(() => {
          function runFilters() {
            setTimeout(() => {
              filtersOn.forEach(obj => {
                gsap.to('.eventBlock.tag' + obj, {opacity: 1})
                gsap.to('.eventIcon.tag' + obj, {opacity: 1})
                if (showActualPredicted) {
                  gsap.to('.eventIconP.tag' + obj, {opacity: 1})
                }
              })
            }, 50);
            
           
          }
          gsap.to('.eventBlock', {opacity: 0, onComplete: runFilters()})
          gsap.to('.eventIconP', {opacity: 0})
          gsap.to('.eventIcon', {opacity: 0, onComplete: runFilters()})
  
        }, 50);
   
        
      } else {
        gsap.to('.eventBlock', {opacity: 1, duration: 0.2})
        gsap.to('.eventIcon', {opacity: 1, duration: 0.2})
        if (showActualPredicted) {
          gsap.to('.eventIconP', {opacity: 1, duration: 0.2})
        }
      }
    }, [filtersOn, events])

    function formatDate(apiDate){
      const parsedDate = parseISO(apiDate);
      const formatted = format(parsedDate, 'LLL dd, y');
      return formatted
    }

    function onSvgLoad(svgId, start_date){
     
      const line = document.querySelector('[data-day="' + start_date + '"]');
      const lineX = line?.offsetLeft ?? 0;
      const centerV = window.innerHeight/2;
      gsap.set("#" + svgId, {left: lineX - 11, top: centerV - 112 });
    }


    function updateParamUrl(name, objIDs){
      let params = new URLSearchParams(props.history.location.search);
      params.set(name, objIDs)
      props.history.replace({ pathname:props.history.location.pathname, search:decodeURIComponent(params.toString())})
  }

    function onEventClick(pageId, objId){
        onClickClose();
        props.onClickModule(-1, true)
        props.onScrollToEvent(parseInt(pageId), 'fade')
        updateParamUrl('timeline', objId + '-' + zoomIndex)
        showActualPredicted && updateParamUrl('predicted', 'true')
    }

        
    function onClickMenuIcon(index) {
      setShowModules(false)
      props.onClickModule(index, true)
    }

  function onFilterBtn(id) {
    let copy = [ ...filtersOn ];
    let index = copy.indexOf(id);
    if (index > -1) {
      copy.splice(index, 1)
    } else {
      copy.push(id)
    }
     setFiltersOn(copy);
  }
    
  function addTagClasses(obj){
    let result = ''
    obj.tags.forEach(obj => 
      result+='tag'+obj.id+" "
    )
    return result
  }

  function getScrollX() {
    let scrollBar = document.getElementById('scrollBar');
    let scrollHandle = document.getElementById('scrollHandle');

    if (scrollBar) {
       const scrollBarRect = scrollBar.getBoundingClientRect();
    const handleRect = scrollHandle.getBoundingClientRect();
    const relativeX = handleRect.left - scrollBarRect.left;
    const scrollBarWidth = scrollBarRect.width;
    const percentageX = (relativeX / scrollBarWidth) * 100;
    setScrollX(percentageX);
    }

   
  }

  function onZoomOut() {
    if (zoomIndex > 0) {
      ref.current.classList.add(styles.zooming);
      // setPrimaryLines(null);

      removeParamUrl('timeline');
      removeParamUrl('predicted');
    function runIndex() {
      let newZoom = zoomIndex
      newZoom-=1
      setZoomIndex(newZoom)
    
    }
    gsap.to('.eventBlock', {opacity: 0, duration: 0.2, onComplete: runIndex()})
    }
  }
  

  function onZoomIn() {
    // console.log('max zoom reached', timeline.lines && timeline.lines.years && timeline.lines.years.length < 10)
    if (zoomIndex < 3) {
     ref.current.classList.add(styles.zooming);
      // setPrimaryLines(null);

      removeParamUrl('timeline');
      removeParamUrl('predicted');
      function runIndex() {
        let newZoom = zoomIndex
        newZoom+=1
        console.log('onZoomIn', newZoom, zoomIndex)
        setZoomIndex(newZoom)
        
      }
      gsap.to('.eventBlock', {opacity: 0, duration: 0.2, onComplete: runIndex()})
    }
  }

  function onZoom(level, callBack){
    function runIndex(callBack) {
      setZoomIndex(parseInt(level))
      callBack();
    }
    runIndex(callBack)
  }

  function toggleSubs(id, e) {
    e.target.classList.toggle(styles.subsOff);
    document.getElementById('subs_' + id).classList.toggle(styles.subsOff);
  }

  function goToEvent(sourceId, targetId, category, crossYearLength, objId){
    setCenterEvent(null);
    setTimeout(() => {
      let source = document.getElementById(sourceId);
      let target = document.getElementById(targetId);
      source.classList.remove(styles.eventOn);
      target.classList.add(styles.eventOn);
      console.log('goToEvent', sourceId, targetId);

      scrollToEvent(targetId);

    if (crossYearLength > 0 && zoom[zoomIndex].level === "year") {
      switch (category) {
        case 'showActual':
          // Handle showing actual events
           Array.from({ length: crossYearLength}).forEach((_, i) => {

              let source = document.getElementById(`event_p_y_${objId}_${i}`);
              let target = document.getElementById(`event_y_${objId}_${i}`);
              source.classList.remove(styles.eventOn);
              target.classList.add(styles.eventOn);
             
            })

          break;

        case 'showPredicted':

          Array.from({ length: crossYearLength}).forEach((_, i) => {

              let source = document.getElementById(`event_y_${objId}_${i}`);
              let target = document.getElementById(`event_p_y_${objId}_${i}`);
              source.classList.remove(styles.eventOn);
              target.classList.add(styles.eventOn);
             
            })

          // Handle showing predicted events
          break;

        default:
          break;
      }
    }
    }, 50);
    
    // Interface with scroll bar
  }

  function scrollToEvent(objId, anim, center) {
    let target = document.getElementById(objId);
    console.log('scrollToEvent', objId, anim, target);
    if (target) {
      let scrollContainerOffset = scrollingContainerRef.current.getBoundingClientRect().left 
      let xPos = target.getBoundingClientRect().left - scrollContainerOffset; 
      
      if (!target.classList.contains(styles.eventOn)) {
        target.classList.add(styles.eventOn);
      }
      let centerOffset = 0;
      let duration = 0.2;
      let duration2 = 0.2;
      if (!anim) {
        duration = 0;
        duration2 = 0;
      }
      if (center) {
        centerOffset = window.innerWidth/2-50
        console.log('centerOffset', centerOffset)
      }
      let scrollWidth = (primaryLines.length + 1) * zoom[zoomIndex].width - 60;
      if (scrollWidth < window.innerWidth || (xPos < window.innerWidth/2)) {
        xPos = 0;
        centerOffset= 0;
      }
      gsap.to(scrollingContainerRef.current, {x: -(xPos-40-centerOffset), duration: duration});

     
      // try {
      //     let barWidth = document.getElementById('scrollBar').getBoundingClientRect().width;
      //     let handleOffset = (xPos/width) * barWidth;
      //     gsap.to("#scrollHandle", {x: (handleOffset-0), duration: duration2})
       
      // } catch (error) {
      //   console.error('Error calculating scroll handle position:', error);
      // }

     let width = document.getElementById('scrollingContainer').getBoundingClientRect().width;
      let barWidth = document.getElementById('scrollBar').getBoundingClientRect().width;
      // let barWidth = (primaryLines.length + 1) * zoom[zoomIndex].width;

      console.log('scrollToEvent width', width, 'barWidth', barWidth, 'xPos', xPos)
      let handleOffset = (xPos/width) * barWidth;
      gsap.to("#scrollHandle", {x: (handleOffset-0), duration: duration2})
     
    }
  }

  function saveCenterLine(){
    const closest = getClosestDatelineToCenter();
    setCenterDay(closest?.dataset.day);
  }

  function onScroll(){
    saveCenterLine();
    // getVisibleEventBlockAtViewportCenter();
  }

  function onSelectEvent(id, isPredicted, selectId) {
    console.log('onSelectEvent', id, isPredicted, selectId)
    getScrollX() 
    if (centerEvent && (centerEvent[0] === id || centerEvent[1] === id)) {
      let selected = id;
      // if (selectId) {
      //   selected = selectId;
      // }
       if (isPredicted && showActualPredicted) {
        if (document.getElementById(selected).classList.contains(styles.eventOn)) {
          setCenterEvent(null);
          setTimeout(() => {
            document.getElementById(selected).classList.add(styles.eventOn)
          }, 20);
        }
      } else {
        setCenterEvent(null);
      }
    } else {
      if (!selectId) {
        selectId = id;
      }
      setCenterEvent([id, selectId]);
    }
  }

  function toggleSubs(id, e) {
    e.target.classList.toggle(styles.subsOff);
    document.getElementById('subs_' + id).classList.toggle(styles.subsOff);
  }

  function onScrollLeft(){
    console.log('onScrollLeft')
    gsap.to('#scrollingContainer', {x: '+=100', duration: 0.2})

  }

  function onScrollRight(){
    console.log('onScrollRight')
        gsap.to('#scrollingContainer', {x: '-=100', duration: 0.2})
  }

  function onScrollUp(){
    console.log('onScrollUp')
   gsap.to('#scrollContainerV', {y: '+=100', duration: 0.2})
  }

  function onScrollDown(){
    console.log('onScrollDown')
      gsap.to('#scrollContainerV', {y: '-=100', duration: 0.2})
   
  }

    return (
        <div className={`fullscreen fcenter ${mstyles.moduleHolder}` } ref={ref}  style={{background: backgroundColor }}>
            {(!loaded)?(<div className={`fullscreen fcenter`}>
            <div>
                <LoaderWheel status={status}></LoaderWheel>
            </div>
             </div>): null }
            
            <div className={styles.heading}>
              <h1>Timeline</h1>
              <h2>{zoom && zoomIndex !== undefined && zoom[zoomIndex].heading}</h2>
            </div>


       <span className={classNames(styles.scrollFade, styles.scrollFadeTop)}></span>
         
        {primaryLines && <div className={styles.timelineBox} id="timelineBox" >
        <div style={{height: '100%', width: `${primaryLines.length * zoom[zoomIndex].width}px`}} className={styles.scrollingContainer} ref={scrollingContainerRef} id="scrollingContainer">

          {zoomIndex !== undefined && primaryLines && timeline && timeline.lines && <div style={{ position: 'relative', width: `${primaryLines.length * zoom[zoomIndex].width}px`, height: '100%'}}>
              {lines && lines.map((obj, i) => (
      
                <div key={'dayLine' + i}
                  data-day={obj.date}
                  data-year={obj.year && obj.year.value}
                  data-month={obj.month && obj.month.value}
                  data-week={obj.week && obj.week.value}
                  className={classNames(styles.dateLine, 'dateLine')}
                  id={'line-' + obj.date}
                  style={{
                    position: 'absolute',
                    left: `${i * zoom[zoomIndex].number}px`,
                    background: (zoom[zoomIndex].level === "year" && obj.year)
                    ? '#FFFFFF'
                    : (zoom[zoomIndex].level === "month" && obj.month)
                    ? getMonth(parseISO(obj.date)) === 0 ? "#FFFFFF" : "#808080"
                    : (zoom[zoomIndex].level === "week" && obj.week)
                    ? ((getMonth(parseISO(obj.date)) === 0 && getDate(parseISO(obj.date)) === 1) ? "#FFFFFF" : 'repeating-linear-gradient(0deg,#808080,#808080 5px,transparent 1px,transparent 10px)')
                    : (zoom[zoomIndex].level === "week" && !obj.week)
                    ? getDate(parseISO(obj.date)) === 1 ? '#808080' :'repeating-linear-gradient(0deg,#808080,#808080 1px,transparent 1px,transparent 5px)'
                    : (zoom[zoomIndex].level === "day")
                    ? getDate(parseISO(obj.date)) === 1 ? '#808080' : ((getMonth(parseISO(obj.date)) === 0 && getDate(parseISO(obj.date)) === 1) ? "#FFFFFF" : 'repeating-linear-gradient(0deg,#808080,#808080 1px,transparent 1px,transparent 5px)')
                    : 'transparent',
                    width: '1px',
                    height: '100%'
                  }}>
                  {obj.year && <div
                    style={{
                      position: 'absolute',
                      left: '6px',
                      top: '-38px',
                      fontFamily:"Gotham",
                      fontWeight: '700',
                      fontSize: '22px',
                      color: '#ffffff',
                    }}>
                      {obj.year.label}
                    </div>}
                  {zoom[zoomIndex].level !== "year" && obj.month && <div
                    style={{
                      position: 'absolute',
                      left: '6px',
                      top: '0px',
                      fontSize: '16px',
                      color: '#808080',
                    }}>
                      {obj.month.label}
                    </div>}
                  {(zoom[zoomIndex].level === "week" || zoom[zoomIndex].level === "day") && obj.day.value !== 1 && <div
                    style={{
                      position: 'absolute',
                      left: '6px',
                      top: '0px',
                      fontSize: '16px',
                      color: '#808080',
                    }}>
                      {obj.day.label}
                    </div>}
  

                </div>
                
                ))}
          </div>}
          {<span id="nowLine" className={styles.nowLineBox}><span className={styles.nowLineCircle
          } /><div className={styles.nowLine}  /></span>}

          <span className={styles.scrollContainerV} id="scrollContainerV">

          {primaryLines && <div className={styles.centerLine} id="centerLine" style={{width: `${primaryLines.length * zoom[zoomIndex].width}px`}} />}

          {events && events.filter(a => !a.multi_day).map((obj, i) => (
            <Fragment key={'event' + i} >
              <span 
              className={classNames(
                styles.eventBlock,
                'eventBlock',
                styles.eventOn,
                obj.tag_classes,
                (centerEvent && centerEvent[0] === 'event_' + obj.id) && styles.eventBlockOn,
                !obj.page && styles.noPage
              )} id={"event_" + obj.id} style={{backgroundColor: obj.color}}>
          
              <span className={styles.eventInner} onClick={() => onSelectEvent('event_' + obj.id)}>
                <span>{obj.icon !== '' && <img src={getContentPath(obj.icon)} alt="" />}</span>
                <span className={styles.eventBlockText}>
                  <span className="flex gap10"> 
                    <h3>{obj.heading}</h3>
                    <span className="flex tags gap10">                       
                      {obj.tags.map((tag, j) => (
                        <span className={styles.tag} key={'eventTag_' + j}>{tag.text}</span>
                      ))}
                    </span>
                  </span>
                  <span className="flex">
           
                  {obj.start_date && <span className="flex gap10">
                    <Calendar /> {showActualPredicted && obj.start_date_predicted && <p>Actual</p>} <p><strong>{formatDate(obj.start_date)}</strong></p>
                  </span>}
                  </span>
                </span>
              </span>
                
                {obj.page && <span onClick={() => onEventClick(obj.page, "event_" + obj.id)} className={styles.eventArrow}><Arrow /></span>}

                { showActualPredicted && obj.start_date_predicted && <span onClick={(e) => goToEvent("event_" + obj.id, "event_p_" + obj.id)} className={styles.pullTab}>See <Calendar /> Predicted</span>  }  
              </span>

              {obj.start_date_predicted &&  <span 
              className={classNames(
                styles.eventBlock,
                styles.eventBlockPredicted,
                showActualPredicted && styles.eventBlockPredictedOn,
                'eventBlock',
                obj.tag_classes,
                (centerEvent && centerEvent[0] === 'event_p_' + obj.id) && styles.eventBlockOn,
                (centerEvent && centerEvent[0] === 'event_p_' + obj.id) && styles.eventOn,
                !obj.page && styles.noPage
              )} id={"event_p_" + obj.id} style={{backgroundColor: obj.color}}>
          
              <span className={styles.eventInner} onClick={() => onSelectEvent('event_p_' + obj.id, true)}>
                <span>{obj.icon !== '' && <img src={getContentPath(obj.icon)} alt="" />}</span>
                <span className={styles.eventBlockText}>
                  <span className="flex gap10"> 
                    <h3>{obj.heading}</h3>
                    <span className="flex tags gap10">                       
                      {obj.tags.map((tag, j) => (
                        <span className={styles.tag} key={'eventTag_' + j}>{tag.text}</span>
                      ))}
                    </span>
                  </span>
                  <span className="flex">
                  {showActualPredicted && obj.start_date_predicted &&  <span className={"flex gap10 " + styles.predicted}>
                     <Calendar /> <p>Predicted</p> <p><strong>{formatDate(obj.start_date_predicted)}</strong></p>
                  </span>}
              
                  </span>
                </span>
              </span>
                
                {obj.page && <span onClick={() => onEventClick(obj.page, "event_" + obj.id)} className={styles.eventArrow}><Arrow /></span>}
                
                { showActualPredicted && <span onClick={(e) => goToEvent("event_p_" + obj.id, "event_" + obj.id)} className={styles.pullTab}>See <Calendar /> Actual</span>  }  

              </span>}

              {obj.start_date_predicted && obj.icon !== '' && (
   
                <span id={"svg_p_" + obj.id} className={classNames('eventIconP', obj.tag_classes, styles.eventIcon, styles.eventIconPredicted, showActualPredicted && styles.showPredicted)}><SVG
                  src={getContentPath(obj.icon + '?cb=143')}
                  cacheRequests={true}
                  width={24}
                  height={24}
                  preProcessor={(code) => code.replace(/fill=".*?"/g, 'fill="' + obj.color + '"')}
                  fetchOptions={{ mode: 'cors', credentials: 'omit' }}
                  onLoad={(svg) => {
                    onSvgLoad("svg_p_" + obj.id, obj.start_date_predicted)
                  }}
                  onError={(error) => console.log(error.message)}
                /></span>

                
              )}
            
              {obj.icon !== '' && (
                <EventIcon
                  id={obj.id}
                  tagClasses={obj.tag_classes}
                  icon={obj.icon}
                  color={obj.color}
                  date={obj.start_date}
                  onSvgLoad={onSvgLoad}
                />
              )}

              
       
            </Fragment>
            ))}

            {events && events.filter(a => a.multi_day).map((obj, i) => (
              <Fragment key={'multi' + i}>
   
               {obj.start_date_predicted && <span className={classNames(
                  styles.eventBlock,
                  styles.multiDayBlock,
                  styles.multiDayPredicted,
                  showActualPredicted && styles.multiDayBlockOn,
                  'eventBlock',
                  'eventBlockMulti',
                  obj.tag_classes,
                  centerEvent && centerEvent[0] === 'event_p_' + obj.id && styles.eventBlockOn,
                  centerEvent && centerEvent[0] === 'event_p_' + obj.id && styles.eventOn,
                  !obj.page && styles.noPage
                )} 
                id={"event_p_" + obj.id}
                style={{backgroundColor: '#404040', width: `${zoom[zoomIndex].width}px`}}>
                <span className={styles.eventMultiDay} onClick={() => onSelectEvent('event_p_' + obj.id, true)}>
                {obj.multi_day && (isCrossYearEvent(obj.start_date, obj.end_date) === -1) && <span className={styles.multiDayBand} style={{backgroundColor: obj.color}}>
                </span>}
                {obj.multi_day && (isCrossYearEvent(obj.start_date, obj.end_date) > 0) && <span className={classNames(styles.multiDayBand, zoom[zoomIndex].level === "year" && styles.crossOverBand)}  style={{backgroundColor: obj.color}}>
                 {zoom[zoomIndex].level === "year" && <svg className={styles.rightPointingTriangle} width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.87 4.4L1.53 0.4C1.18 0.14 0.76 0 0.33 0H0V12H0.33C0.76 12 1.18 11.86 1.53 11.6L6.86 7.6C7.93 6.8 7.93 5.2 6.86 4.4H6.87Z" fill={obj.color}/>
                </svg>}
                </span>}
            
                <span className={styles.eventInnerBox} onClick={() => onSelectEvent('event_p_' + obj.id, true)}>
                <span className={styles.eventInner} >
                
                  <span className={styles.eventBlockText}>
                    <span className="flex gap10">
                      <h3>{obj.heading}</h3>
                      <span className="flex tags gap10">                       
                        {obj.tags.map((tag, j) => (
                          <span className={styles.tag} key={'eventTag_' + j}>{tag.text}</span>
                        ))}
                      </span>
                    </span>

                    <span className="flex">
                     <span className={"flex gap10 " + styles.predicted}>
                    <Calendar /> <p>Predicted</p> <p><strong>{parseInt(obj.days_predicted/7)} {(obj.days_predicted/7 >= 2) ? "Weeks" : "Week"} ({obj.days_predicted} Days)</strong></p>
                    </span>
                    </span>

                  </span>
                </span>
                  
                  {obj.page && <span onClick={() => onEventClick(obj.page, "event_p_" + obj.id)}  className={styles.eventArrow}><Arrow /></span>}
                  </span>
                  </span> 
                  <span onClick={(e) => goToEvent("event_p_" + obj.id, "event_" + obj.id, 'showActual', isCrossYearEvent(obj.start_date, obj.end_date) > 0, obj.id)} className={styles.pullTab}>See <Calendar /> Actual</span>         
                </span>}

                <span className={classNames(
                  styles.eventBlock,
                  styles.multiDayBlock,
                  showActualPredicted && styles.multiDayBlockOn,
                  styles.eventOn,
                  'eventBlock',
                  obj.tag_classes,
                  (zoom[zoomIndex].level === "year" && centerEvent && centerEvent[0] === 'event_' + obj.id) && styles.eventBlockOn,
                  (zoom[zoomIndex].level !== "year" && centerEvent && centerEvent[1] === 'event_' + obj.id) && styles.eventBlockOn,
                  !obj.page && styles.noPage
                )} 
                id={"event_" + obj.id}
                style={{backgroundColor: '#404040', width: `${zoom[zoomIndex].width}px`}}>
                <span className={styles.eventMultiDay}>


                {obj.multi_day && (isCrossYearEvent(obj.start_date, obj.end_date) <= 0) && <span className={styles.multiDayBand} style={{backgroundColor: obj.color}} onClick={() => onSelectEvent('event_' + obj.id)} />}

                {obj.multi_day && (isCrossYearEvent(obj.start_date, obj.end_date) > 0) && <span className={classNames(styles.multiDayBand, zoom[zoomIndex].level === "year" && styles.crossOverBand)} style={{backgroundColor: obj.color}}>
               {zoom[zoomIndex].level === "year" && <svg className={styles.rightPointingTriangle} width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.87 4.4L1.53 0.4C1.18 0.14 0.76 0 0.33 0H0V12H0.33C0.76 12 1.18 11.86 1.53 11.6L6.86 7.6C7.93 6.8 7.93 5.2 6.86 4.4H6.87Z" fill={obj.color}/>
                </svg>}
                </span>}

                <span className={styles.eventInnerBox} onClick={() => onSelectEvent('event_' + obj.id)}>
                <span className={styles.eventInner}>
                
                  <span className={styles.eventBlockText}>
                    <span className="flex gap10">
                      <h3>{obj.heading}</h3>
                      <span className="flex tags gap10">                       
                        {obj.tags.map((tag, j) => (
                          <span className={styles.tag} key={'eventTag_' + j}>{tag.text}</span>
                        ))}
                      </span>
                    </span>

                    <span className="flex">
             
                    <span className="flex gap10">
                    <Calendar /> {obj.start_date_predicted && showActualPredicted && <p>Actual</p>} <p><strong>{parseInt(obj.days/7)} {(obj.days/7 >= 2) ? "Weeks" : "Week"} ({obj.days} Days)</strong></p>
                    </span>
                    </span>

                  </span>
         
                </span>
                  
                  {obj.page && <span onClick={() => onEventClick(obj.page, "event_" + obj.id)} className={styles.eventArrow}><Arrow /></span>}
                  </span>
                  </span>  
                  {obj.start_date_predicted && showActualPredicted && <span onClick={(e) => goToEvent("event_" + obj.id, "event_p_" + obj.id, 'showPredicted', isCrossYearEvent(obj.start_date, obj.end_date), obj.id)} className={styles.pullTab}>See <Calendar /> Predicted</span>}        
                </span>

                {(isCrossYearEvent(obj.start_date, obj.end_date) > 0) && zoom[zoomIndex].level === "year" &&
                  Array.from({ length: isCrossYearEvent(obj.start_date, obj.end_date)}).map((_, i) => (
                    <Fragment key={`event_y_${obj.id}_${i}`}>

                     {obj.start_date_predicted && <span
                      parent={`event_p_${obj.id}`}
                      className={classNames(
                        styles.eventBlock,
                        styles.multiDayBlock,
                        styles.multiDayPredicted,
                        showActualPredicted && styles.multiDayBlockOn,
                        // styles.eventOn,
                        'eventBlock',
                        'eventBlockMulti',
                        styles.multiYearEventMiddle,
                        (i + 1) === isCrossYearEvent(obj.start_date, obj.end_date) && styles.multiYearEventMiddleEnd,
                        obj.tag_classes,
                        // (zoom[zoomIndex].level === "year" && centerEvent && centerEvent[0] === `event_p_y_${obj.id}_${i}`) && styles.eventBlockOn,
                        centerEvent && centerEvent[0] === `event_p_y_${obj.id}_${i}` && styles.eventOn,
                        centerEvent && centerEvent[0] === `event_p_y_${obj.id}_${i}` && styles.eventBlockOn,
                        !obj.page && styles.noPage
                      )}
                     
                      id={`event_p_y_${obj.id}_${i}`}
                      style={{ backgroundColor: '#404040', width: `${zoom[zoomIndex].width}px` }}
                    >
                      <span className={styles.eventMultiDay}>
                        {obj.multi_day && (isCrossYearEvent(obj.start_date, obj.end_date) === 0) && (
                          <span className={styles.multiDayBand} style={{ backgroundColor: obj.color }} />
                        )}
                        {obj.multi_day && (isCrossYearEvent(obj.start_date, obj.end_date) > 0) && (
                          <span className={classNames(styles.multiDayBand, styles.crossOverBand, styles.crossOverBandEnd)} style={{ backgroundColor: obj.color }}>
                            {zoom[zoomIndex].level === "year" && (
                              <svg className={styles.leftPointingTriangle} width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.87 4.4L1.53 0.4C1.18 0.14 0.76 0 0.33 0H0V12H0.33C0.76 12 1.18 11.86 1.53 11.6L6.86 7.6C7.93 6.8 7.93 5.2 6.86 4.4H6.87Z" fill={obj.color}/>
                              </svg>
                            )}
                            {zoom[zoomIndex].level === "year" && (
                              <svg className={styles.rightPointingTriangle} width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.87 4.4L1.53 0.4C1.18 0.14 0.76 0 0.33 0H0V12H0.33C0.76 12 1.18 11.86 1.53 11.6L6.86 7.6C7.93 6.8 7.93 5.2 6.86 4.4H6.87Z" fill={obj.color}/>
                              </svg>
                            )}
                          </span>
                        )}
                        <span className={styles.eventInnerBox} onClick={() => onSelectEvent(`event_p_y_${obj.id}_${i}`, false, `event_${obj.id}`)}>
                          <span className={styles.eventInner} >
                            <span className={styles.eventBlockText}>
                              <span className="flex gap10">
                                <h3>{obj.heading}</h3>
                                <span className="flex tags gap10">
                                  {obj.tags.map((tag, j) => (
                                    <span className={styles.tag} key={'eventTag_' + j}>{tag.text}</span>
                                  ))}
                                </span>
                              </span>
                              <span className="flex">
                                <span className="flex gap10">
                                  <Calendar /> {obj.start_date_predicted && showActualPredicted && <p>Predicted</p>} <p><strong>{parseInt(obj.days_predicted/7)} {(obj.days_predicted/7 >= 2) ? "Weeks" : "Week"} ({obj.days_predicted} Days)</strong></p>
                                </span>
                              </span>
                            </span>
                          </span>
                          {obj.page && (
                            <span onClick={() => onEventClick(obj.page, "event_" + obj.id)} className={styles.eventArrow}><Arrow /></span>
                          )}
                        </span>
                      </span>
                      
                    </span>}

                    <span
                      // key={`event_y_${obj.id}_${i}`}
                      parent={`event_${obj.id}`}
                      className={classNames(
                        styles.eventBlock,
                        styles.multiDayBlock,
                        showActualPredicted && styles.multiDayBlockOn,
                        styles.eventOn,
                        'eventBlock',
                        styles.multiYearEventMiddle,
                        (i + 1) === isCrossYearEvent(obj.start_date, obj.end_date) && styles.multiYearEventMiddleEnd,
                        obj.tag_classes,
                        (zoom[zoomIndex].level === "year" && centerEvent && centerEvent[0] === `event_y_${obj.id}_${i}`) && styles.eventBlockOn,
                        !obj.page && styles.noPage
                      )}
                     
                      id={`event_y_${obj.id}_${i}`}
                      style={{ backgroundColor: '#404040', width: `${zoom[zoomIndex].width}px` }}
                    >
                      <span className={styles.eventMultiDay}>
                        {obj.multi_day && (isCrossYearEvent(obj.start_date, obj.end_date) === 0) && (
                          <span className={styles.multiDayBand} style={{ backgroundColor: obj.color }} />
                        )}
                        {obj.multi_day && (isCrossYearEvent(obj.start_date, obj.end_date) > 0) && (
                          <span className={classNames(styles.multiDayBand, styles.crossOverBand, styles.crossOverBandEnd)} style={{ backgroundColor: obj.color }}>
                            {zoom[zoomIndex].level === "year" && (
                              <svg className={styles.leftPointingTriangle} width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.87 4.4L1.53 0.4C1.18 0.14 0.76 0 0.33 0H0V12H0.33C0.76 12 1.18 11.86 1.53 11.6L6.86 7.6C7.93 6.8 7.93 5.2 6.86 4.4H6.87Z" fill={obj.color}/>
                              </svg>
                            )}
                            {zoom[zoomIndex].level === "year" && (
                              <svg className={styles.rightPointingTriangle} width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.87 4.4L1.53 0.4C1.18 0.14 0.76 0 0.33 0H0V12H0.33C0.76 12 1.18 11.86 1.53 11.6L6.86 7.6C7.93 6.8 7.93 5.2 6.86 4.4H6.87Z" fill={obj.color}/>
                              </svg>
                            )}
                          </span>
                        )}
                        <span className={styles.eventInnerBox} onClick={() => onSelectEvent(`event_y_${obj.id}_${i}`, false, `event_${obj.id}`)}>
                          <span className={styles.eventInner} >
                            <span className={styles.eventBlockText}>
                              <span className="flex gap10">
                                <h3>{obj.heading}</h3>
                                <span className="flex tags gap10">
                                  {obj.tags.map((tag, j) => (
                                    <span className={styles.tag} key={'eventTag_' + j}>{tag.text}</span>
                                  ))}
                                </span>
                              </span>
                              <span className="flex">
                                <span className="flex gap10">
                                  <Calendar /> {obj.start_date_predicted && showActualPredicted && <p>Actual</p>} <p><strong>{parseInt(obj.days/7)} {(obj.days/7 >= 2) ? "Weeks" : "Week"} ({obj.days} Days)</strong></p>
                                </span>
                              </span>
                            </span>
                          </span>
                          {obj.page && (
                            <span onClick={() => onEventClick(obj.page, "event_" + obj.id)} className={styles.eventArrow}><Arrow /></span>
                          )}
                        </span>
                      </span>
                   
                    </span>
                    </Fragment>
                  ))
                }

              </Fragment>
              ))}




          </span>


        </div>
        <span>
     
        </span>
      </div>
      }


      <div className={styles.scrollArrowBox}>
         <div className={`round-btn`} onClick={() => onScrollUp()}><CaretUp /></div>
          <div className={`round-btn`} onClick={() => onScrollDown()}><CaretDown /></div>
      </div>

      {events && primaryLines && primaryLines.length > 0 && lines && scrollingContainerRef.current && <span className={styles.scrollBarBox}>
        <ScrollBar draggable={(((primaryLines.length + 1) * zoom[zoomIndex].width) - 60) < window.innerWidth ? false : true} onScroll={onScroll} scrollingContainer={scrollingContainerRef.current} firstEventId={events[0].id} width={(primaryLines.length + 1) * zoom[zoomIndex].width} height={8} isVertical={false} scrollBarPos={scrollBarPos} /></span>}

        {events && primaryLines && eventBlocksHeight && <span className={styles.scrollBarBoxV}>
        <ScrollBar draggable={true} scrollingContainer={'#scrollContainerV'} width={8} height={eventBlocksHeight} isVertical={true} scrollBarPos={scrollBarPos} /></span>}

       

      <span className={styles.scrollFade}></span>
      {timeline && <div className={classNames(
        styles.leftNav,
        navOpen && styles.on,
        filters && filters.length > 0 && styles.hasFilters,
        nStyles.leftNav
      )}>
      
        <span className={styles.filterNav}>


         <span className={nStyles.menuInnerColumn}>

      {props.logo && <img src={getContentPath(props.logo)} alt="logo" className={`${nStyles.logo} logo`} />}

              <span className={styles.leftNavTitle}>

              <div className={`${nStyles.menuTitle}`}>{props.model.heading}</div>

      
          <span className={nStyles.switchMenu} onClick={() => setShowModules(showModules => !showModules)}><span className={classNames(nStyles.switchMenuBtn, styles.switchMenuBtn)}><Apps /></span><h4>{timeline.title}</h4></span>

        
          {showModules && props.icons &&
            <span className={classNames(nStyles.menuModuleContainer, styles.menuModules)}>                  
              <div className={`${nStyles.menuColPos} ${showModules?nStyles.menuColOn:""}`}><div className={`${nStyles.menuModuleContainer} ifServerHide ${styles.timelineModuleMenu}`} style={Globals.instance().getThemeStyle(['nav-modules-container'],props.theme)}>

              {props.icons.map((icon, index) =>{
                  return (
                      <div className={`${nStyles.moduleLink}`} key={`nar-menu-mode-item-${index}`} index={index-1} 
                      onClick={() => onClickMenuIcon(index-1)}>
                          <span className={`${nStyles.moduleLinkIcon}`}>{icon}</span>
                      </div>
              )})}
              
              </div></div>
            </span>
        }

        </span>
       </span>
        </span>
        {timeline.tags && timeline.tags.length > 0 ? 

         <Fragment>{!showModules && <span className={styles.leftNavInner}>
            <span className={styles.leftNavHeading}>
              <h2>Filters</h2>
              <span className={styles.pillBtn} onClick={() => setFiltersOn([])}>Clear All</span>
            </span>
            {filters && filters.map((obj, i) => (
              <span key={'filter' + i}>
              <span className={classNames(
                styles.filterParent,
                obj.children.length > 0 ? styles.hasChildren : styles.noChildren
              )}>
              {obj.children.length > 0 && <CaretDown className={styles.filterCaret} onClick={(e) => toggleSubs(obj.id, e)} />}
                <h2>{obj.text}</h2>

                {obj.children.length === 0 && <span 
                  onClick={() => onFilterBtn(obj.id)}
                  className={classNames(
                    styles.filterBox,
                    filtersOn.indexOf(obj.id) > -1 && styles.filterBoxOn
                  )}></span>}  

              </span>
              <span id={'subs_' + obj.id} className={styles.filterSubs}> 
              {obj.children && obj.children.map((obj1, i) => (
                <span key={i} className={styles.filterChild}>
                  <p>{obj1.text}</p>
                  <span 
                  onClick={() => onFilterBtn(obj1.id)}
                  className={classNames(
                    styles.filterBox,
                    filtersOn.indexOf(obj1.id) > -1 && styles.filterBoxOn
                  )}></span>  
             
                </span>
              ))}
              </span>
              </span>
            ))}
            </span>}
            

         </Fragment>
          :
          !showModules && <span className={styles.noFilters}>
          <FilterIcon />
          <h2>No Filters Yet</h2>
          <p>Once filter tags are created, you will be able to view them here</p>
        </span>
      
        }
      </div>}
     
      <span className={`fullscreen fcenter ${styles.pillBox}` }>

       <div className={`round-btn ${styles.scrollArrow}`} onClick={() => onScrollLeft()}><CaretLeft /></div>

      {timeline && timeline.has_predicted && <div className={`round-btn`} onClick={() => setShowActualPredicted(prev => !prev)}><Predict /></div>}

          <span className={classNames(nStyles.controlsPill, !centerEvent && styles.noAction)}>
            
            <ZoomOut onClick={() => onZoomOut()}/>
            <span className={`${nStyles.controlsPillLine}`} />
            <ZoomIn 
              className={classNames(zoomIndex !== 0 && (timeline && timeline.lines && timeline.lines.years && timeline.lines.years.length > 9) && styles.disabled)}
              onClick={() => onZoomIn()} 
              />

          </span>

          <div className={`round-btn ${styles.scrollArrow}`} onClick={() => onScrollRight()}><CaretRight /></div>

          {centerEvent && <span className={styles.pillBtn} onClick={() => setCenterEvent(null)}>Clear</span>}
      </span>
          <span className={classNames(nStyles.leftNav, styles.buttonContainer)}>
             <div className={`${nStyles.buttonContainer} ${styles.buttonContainer} ifServerHide`}>

                <div onClick={() => setNavOpen(prev => !prev)} ><div className={`round-btn`}><Burger /></div></div>
                  

                <span className={nStyles.homeBtnCol}>
                  {navOpen && <div className={`${nStyles.homeBtn} ${styles.homeBtn}`} onClick={onClickClose} style={Globals.instance().getThemeStyle(['nav-menu-btn'],props.theme)}>
                      <Home />
                  </div>}


                  {navOpen && <div className={`${nStyles.toolBtn} ${styles.toolBtn}`}><ToolsMenu theme={props.theme} 
                  setShowDrawControls={props.setShowDrawControls} 
                  setShowControls={props.setShowControls} 
                  setShowMarkup={props.setShowMarkup}
                  model={props.model}
                  
                  ></ToolsMenu></div>}
                  </span>   

             </div>
          </span>
        </div>
        
        
    )

})

export default Timeline


